export const formatPrice = (price) => {
    const format = (formatMe) =>
        formatMe.toLocaleString('sv', {
            symbol: ' kr',
            symbolPosition: 'end',
            decimal: ',',
            comma: '.'
        });
    return typeof price !== 'number'
        ? `${format(parseInt(price))} kr`
        : `${format(price)} kr`;
};
